"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageSchemaProperties = exports.PackageSchema = exports.ServiceFee = exports.ServiceFeeTypeEnum = exports.ServiceFeePaymentMethodsEnum = exports.PackageOnTrackRulesType = exports.OnTrackNotificationsType = exports.PackageTrackingNotificationType = exports.PackageBillingRateTypeSchema = exports.PackageTypeSchema = exports.PackagePaymentOptionSchema = exports.UsagePackagePricingSchema = exports.UsagePackageInvoicingSchema = exports.UsagePackageInvoiceCutOffDateSchema = exports.PackageFrequencySchema = exports.PackageFrequencyTypeSchema = exports.PackageTimeTypeSchema = exports.PackageContentTypeSchema = exports.PackageStatusSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const intuit_realm_1 = require("./intuit-realm");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
exports.PackageStatusSchema = zod_1.z.enum(["active", "inactive", "deleted"]);
exports.PackageContentTypeSchema = zod_1.z.enum(["sessions", "time"]);
exports.PackageTimeTypeSchema = zod_1.z.enum(["minutes", "hours"]);
exports.PackageFrequencyTypeSchema = zod_1.z.enum(["months", "weeks", "years"]);
exports.PackageFrequencySchema = zod_1.z.object({
    total: zod_1.z.number(),
    type: exports.PackageFrequencyTypeSchema,
});
exports.UsagePackageInvoiceCutOffDateSchema = zod_1.z.enum([
    // monthly
    "first-of-month",
    "last-of-month",
    // weekly
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
]);
exports.UsagePackageInvoicingSchema = zod_1.z.object({
    method: zod_1.z.enum(["auto", "manual", "subscription"]),
    period: zod_1.z.enum(["months", "weeks"]),
    autoChargeDay: zod_1.z.number().optional(),
    cutOffDate: exports.UsagePackageInvoiceCutOffDateSchema.optional(),
    dueAfterDays: zod_1.z.number().optional(),
    subscriptionAmount: zod_1.z.number().optional(),
});
exports.UsagePackagePricingSchema = zod_1.z.object({
    amount: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
});
const PackageItemSchema = zod_1.z.object({
    productId: zod_1.z.string().optional(),
    schedulerId: zod_1.z.string(),
    quantity: zod_1.z.number(),
    order: zod_1.z.number().optional(),
    usagePricing: exports.UsagePackagePricingSchema.optional(),
    suggestedFrequency: exports.PackageFrequencySchema.optional(),
    billingRateId: zod_1.z.string().optional(),
    curriculum: zod_1.z.boolean().optional(),
    isUnlimited: zod_1.z.boolean().optional(),
});
const PackagePaymentTypesSchema = zod_1.z.enum(["one-time", "split-payments"]);
const PackagePaymentSplitPeriodSchema = zod_1.z.enum(["months", "weeks"]);
const PackagePaymentSplitSchema = zod_1.z.object({
    unit: zod_1.z.string(),
    amount: zod_1.z.number(),
    total: zod_1.z.number(),
    dueOn: zod_1.z.number(),
    itemAmount: zod_1.z.number(),
    period: PackagePaymentSplitPeriodSchema,
});
exports.PackagePaymentOptionSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    type: PackagePaymentTypesSchema,
    amount: zod_1.z.number(),
    currency: zod_1.z.string(),
    taxTypeId: zod_1.z.string(),
    splits: PackagePaymentSplitSchema.array(),
    couponId: zod_1.z.string().optional(),
});
exports.PackageTypeSchema = zod_1.z.enum([
    "recurring",
    "one-time",
    "flexible",
    "usage",
    "subscription",
]);
exports.PackageBillingRateTypeSchema = zod_1.z.enum(["multi", "single"]);
exports.PackageTrackingNotificationType = zod_1.z.object({
    afterDays: zod_1.z.number(),
    clientMessage: zod_1.z.string().optional(),
    sendToClient: zod_1.z.boolean(),
    sendToMember: zod_1.z.boolean(),
});
exports.OnTrackNotificationsType = zod_1.z.object({
    atRisk: zod_1.z.array(exports.PackageTrackingNotificationType).optional().nullable(),
    offTrack: zod_1.z.array(exports.PackageTrackingNotificationType).optional().nullable(),
});
exports.PackageOnTrackRulesType = zod_1.z.object({
    atRiskSessionCount: zod_1.z.number().nullable(),
    offTrackSessionCount: zod_1.z.number(),
    onTrackDaysInterval: zod_1.z.number(),
    allowClientView: zod_1.z.boolean(),
});
exports.ServiceFeePaymentMethodsEnum = zod_1.z.enum(["cc", "ach"]);
exports.ServiceFeeTypeEnum = zod_1.z.enum(["percentage", "flat"]);
exports.ServiceFee = zod_1.z.object({
    amount: zod_1.z.number(),
    type: exports.ServiceFeeTypeEnum,
    title: zod_1.z.string().optional(),
    termsAgreedAt: zod_1.z.date(),
    actorId: zod_1.z.string(),
    appliedToPaymentMethods: zod_1.z.array(exports.ServiceFeePaymentMethodsEnum),
});
exports.PackageSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    internalName: zod_1.z.string().optional(),
    slug: zod_1.z.string(),
    description: zod_1.z.string(),
    icon: zod_1.z.string(),
    smartActionTemplates: smart_action_schema_1.SmartActionTemplateSchema.array().optional(),
    items: PackageItemSchema.array(),
    paymentOptions: exports.PackagePaymentOptionSchema.array().default([]),
    status: exports.PackageStatusSchema,
    secret: zod_1.z.boolean().optional(),
    publicOrder: zod_1.z.number().optional().nullable(),
    acceptedOutcomes: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    autoCancelOutcome: zod_1.z.boolean().optional().nullable(),
    rollOver: zod_1.z.boolean().optional(),
    distributeSessions: zod_1.z.boolean().optional(),
    totalSessions: zod_1.z.number().nullable().optional(),
    contentType: exports.PackageContentTypeSchema.optional(),
    timeType: exports.PackageTimeTypeSchema.nullable().optional(),
    autocomplete: zod_1.z.boolean().optional(),
    packageType: exports.PackageTypeSchema.optional(),
    frequency: exports.PackageFrequencySchema.nullable().optional(),
    billingRateId: zod_1.z.string().nullable().optional(),
    packageBillingRateType: exports.PackageBillingRateTypeSchema.optional().nullable(),
    usageInvoicing: exports.UsagePackageInvoicingSchema.optional().nullable(),
    locked: zod_1.z.boolean().optional(),
    depositRule: zod_1.z.enum(["start-of-engagement", "end-of-engagement"]).optional(),
    couponIds: zod_1.z.array(zod_1.z.string()).optional(),
    onTrackNotifications: exports.OnTrackNotificationsType.optional().nullable(),
    onTrackRules: exports.PackageOnTrackRulesType.optional().nullable(),
    allowFutureBooking: zod_1.z.boolean().optional(),
    earliestStartDate: zod_1.z.date().optional().nullable(),
    quickBooks: intuit_realm_1.IntuitQuickBooksPackageInfoSchema.optional(),
    paymentSettings: zod_1.z
        .object({
        taxTypeId: zod_1.z.string(),
        currency: zod_1.z.string(),
    })
        .optional(),
    serviceFee: exports.ServiceFee.optional().nullable(),
    expiration: zod_1.z
        .object({
        type: zod_1.z.enum(["date", "months", "days"]),
        date: zod_1.z.date().optional().nullable(),
        quantity: zod_1.z.number().optional().nullable(),
    })
        .optional()
        .nullable(),
    cancellationFormTemplateId: zod_1.z.string().optional().nullable(),
    allowClientTierChanges: zod_1.z.boolean().optional(),
});
exports.PackageSchemaProperties = {
    collectionName: "packages",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=package-schema.js.map